import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { FormGroup, FormControl, ReactiveFormsModule, Validators, ValidatorFn, AbstractControl } from '@angular/forms';
import { UserService } from '../services/user.service';
import { AjaxService } from '../services/ajax.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, RouterLink, ReactiveFormsModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent {

  userSubscription : Subscription[] = [];
  submitted = false;
  disableBtn = false;
  
  loginForm = new FormGroup({
    email: new FormControl('', [Validators.required, this.noWhitespaceValidator()]),
    password: new FormControl('', [Validators.required, this.noWhitespaceValidator()]),
  });

  

  constructor (private _userServices : UserService, private _router : Router, private _ajaxService: AjaxService, private _bar : MatSnackBar) {}

  ngOnInit(): void {
    this.userSubscription.push(this._userServices.getUserDetails().subscribe(value => {
      if (value != undefined && Object.keys(value).length > 0) {
        this._router.navigate(['/dashboard'])
      } else if (localStorage.getItem('CSIPUser') != null) {
        const user = JSON.parse(localStorage.getItem('CSIPUser') || '{}')
        this._userServices.setUserDetails(user);
        this._router.navigate(['/dashboard'])
      }
    }))

    this._userServices.getSpinner().subscribe((value: any) => {
      if (value === true) {
        this.disableBtn = true
      } else {
        this.disableBtn = false
      }
    })
  }

  onSubmit() {
    this.submitted = true;
    if (this.loginForm.valid) {
      this.login(this.loginForm.value.email, this.loginForm.value.password)
    }
  }

  noWhitespaceValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const isWhitespace = (control.value || '').trim().length === 0;
      const isValid = !isWhitespace;
      return isValid ? null : { 'whitespace': true };
    };
  }

  get f() { return this.loginForm.controls; }

  login(email: any, password: any) {
    const request = {
      "email": email,
      "password": password,
    }
    this._ajaxService.post("users/login", request).then((response: any) => {
      
      if (response.statusCode == 200) {
        const {userData, schoolData} = response.data
        
        const user = {
          id : userData[0].id,
          firstName: userData[0]['firstName'],
          lastName: userData[0]['lastName'],
          email: userData[0]['email'],
          role: userData[0]['role'],
          userId : userData[0]['id'],
          showTour : userData[0]['showTour'],
        }
        localStorage.setItem('schools', JSON.stringify(schoolData))
        localStorage.setItem('CSIPUser', JSON.stringify(user));
        this._userServices.setUserMenu(true);
        this._userServices.setUserDetails(user);
        this._router.navigate(['/dashboard'])
      }
    })
    .catch(error => {
      let displayError = error.error.message
      if (error.error.message === undefined) displayError = `Technical Issue Please Try Again!`
      this._bar.open(`${displayError}`, "OK", { duration: 3000, panelClass: "error-dialog" })
    })
  }

  ngOnDestroy() {
    this.userSubscription.forEach(value => {
      value.unsubscribe();
    })
  }

}